module.exports = __webpack_public_path__ + "img/813.234529d0.png";